import React, { useEffect, useState, useCallback } from "react";
import { FACEBOOK } from "../../variables/general";
import { connectNewDevice, deleteDevices, getConnectedDevice, getWhatsappEncryptedTextUrl, getWhatsappUserToken, setDefault } from "../common/whatsapp";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
  Typography,
  Box,
  useMediaQuery,
  useTheme,
} from "@material-ui/core";
import { Card, CardContent, Grid } from '@material-ui/core';

import GridItem from "components/Grid/GridItem.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import { API_POST } from "../../services/api.service";
import { cacheUtil } from "../../services/Common";
import InfoBox from "../../components/InfoIcon/InfoIcon";


const FacebookWhatsAppSignup = (props) => {
  const { admin, username , id, whatsappPhoneId } = props.user
  const {history}= props;
  const [ whatsappCode,setWhatsappCode ]= useState({
    phoneNumberId: "",
    whatsappBusinessAccountId: "",
    responseCode: "",
  });
  let whatsapValue = {};
  const [authCode,setAuthCode] = useState(null);
  const [connectedDevices, setConnectedDevices] = useState(props.devicesList);

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  // Initialize Facebook SDK
  useEffect(() => {
    window.fbAsyncInit = function() {
      window.FB.init({
        appId: FACEBOOK.APP_ID,
        autoLogAppEvents: true,
        xfbml: true,
        version: "v22.0",
      });
    };

    // Load Facebook SDK script
    const script = document.createElement("script");
    script.src = "https://connect.facebook.net/en_US/sdk.js";
    script.async = true;
    script.defer = true;
    script.crossOrigin = "anonymous";
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  // Handle messages from Facebook's embedded signup flow
  useEffect(() => {
    const handleMessage = (event) => {
      if (
        event.origin !== "https://www.facebook.com" &&
        event.origin !== "https://web.facebook.com"
      ) {
        return;
      }
      try {
        const data = JSON.parse(event.data);
        if (data.type === "WA_EMBEDDED_SIGNUP") {
          if (data.event === "FINISH") {
            const { phone_number_id, waba_id } = data.data;
            setWhatsappCode({...whatsappCode,
              phoneNumberId: phone_number_id,
              whatsappBusinessAccountId: waba_id,
            });
            whatsapValue = {phoneNumberId: phone_number_id,
              whatsappBusinessAccountId: waba_id}

            console.log(
              "Phone number ID:",
              phone_number_id,
              "WhatsApp business account ID:",
              waba_id
            );
          } else if (data.event === "CANCEL") {
            console.warn("Cancel at:", data.data.current_step);
          } else if (data.event === "ERROR") {
            console.error("Error:", data.data.error_message);
          }
        }
        document.getElementById(
          "session-info-response"
        ).textContent = JSON.stringify(data, null, 2);
      } catch (error) {
        console.log("Non-JSON response:", event.data);
      }
    };

    window.addEventListener("message", handleMessage);
    return () => {
      window.removeEventListener("message", handleMessage);
    };
  }, []);


  useEffect( () => {

    console.log("whatsappCode",whatsappCode,authCode);
    if(authCode && whatsappCode.phoneNumberId ){
      connectDevice();
      
    }

  }, [whatsappCode,authCode])

  const connectDevice = async () =>{
    const connectNew = await connectNewDevice({...whatsappCode,default:connectedDevices.length ? false :true,admin,username});
    console.log("new device response...",connectNew,whatsappCode);
    window.location.reload();
  }

  const deleteDevice = async (element) =>{
    const connectNew = await deleteDevices(element);
    console.log("new device response...",connectNew);
  }

  // Facebook login callback
  const fbLoginCallback = useCallback((response) => {
    if (response.authResponse) {
      const code = response.authResponse.code;
      setWhatsappCode({...whatsapValue,
        responseCode: code
      });
      console.log("Auth Code:", code);
      console.log("WhatsApp Code:", whatsappCode,whatsapValue);
      console.log("code setting...")
      setAuthCode(code);
    }
    document.getElementById("sdk-response").textContent = JSON.stringify(
      response,
      null,
      2
    );
  }, []);

  // Launch WhatsApp signup flow
  const launchWhatsAppSignup = useCallback(() => {
    window.FB.login(fbLoginCallback, {
      config_id:  FACEBOOK.CONFIG_ID,
      response_type: "code",
      override_default_response_type: true,
      extras: {
        setup: {},
        featureType: "",
        sessionInfoVersion: "2",
      },
    });
  }, [fbLoginCallback]);

  // Render connected devices table

const inbox = async (device) => {

  const listConnectedDevices = connectedDevices.map((device) => {
    return {
      id: device.id,
      phoneNumberId: device.phoneNumberId,
      whatsappBusinessAccountId: device.whatsappBusinessAccountId,
      phoneNumber: device.getPhoneDetailsResponse.display_phone_number,
  }})

  const userwhatsappData = await getWhatsappUserToken();
  const testObj = {
    showPhoneSelection: true,
    listConnectedDevices: listConnectedDevices,
    admin: device.admin,
    userId: userwhatsappData.userId,
    token: userwhatsappData.token,
    phoneNumberId: device.phoneNumberId
  };

  const encryptedTest = await getWhatsappEncryptedTextUrl(testObj);

  // Open in new tab
  window.open(`https://metawhatsapp.betyphon.in/inbox/?data=${encryptedTest}`, '_blank');
}


const savewhatsappPhoneId = async (device) => {
  try {

    const result  = await setDefault(device)
  
    console.log("response",result);
   // window.location.reload();
  } catch (error) {
  }
}

  return (

    <GridContainer>        
      <GridItem xs={12} sm={12} md={12}>
        <br/>
        <Box sx={{ padding: 3 }}>
          <br/>
          <div id="fb-root" />
         
          
          <Button
            onClick={launchWhatsAppSignup}
            variant="contained"
             color="primary"
            style={{
              float:"right",
              fontWeight: "bold",          
              padding: "10px 24px",
            }}
          >
            Login with Facebook
          </Button>
           <span style={{float:"right",margin:"5px"}}>
            <InfoBox name={'Whatsapp.connect'} />
          </span>
          <br/>
          <pre style={{ display: "none" }} id="session-info-response" />
          <pre id="sdk-response" style={{ display: "none" }} />

          <Grid container spacing={3} sx={{ marginTop: 4 }}>
      {connectedDevices && connectedDevices.map((device) => (
        <Grid item xs={12} sm={6} md={4} key={device._id}>
          <Card variant="outlined">
            <CardContent>
              {/* ID */}
              <Typography variant="subtitle1" gutterBottom>
                <strong>Connection ID:</strong> {device._id}
              </Typography>

              {/* Phone ID */}
              <Typography variant="body1" gutterBottom>
                <strong>Phone ID:</strong> {device.phoneNumberId}
              </Typography>

              {/* WhatsApp ID */}
              <Typography variant="body1" gutterBottom>
                <strong>WhatsApp ID:</strong> {device.whatsappBusinessAccountId}
              </Typography>

              {/* Phone Number */}
              <Typography variant="body1" gutterBottom>
                <strong>Phone Number:</strong> {device.getPhoneDetailsResponse.display_phone_number}
              </Typography>

              {/* Status */}
              <Typography variant="body1" gutterBottom>
                <strong>Status:</strong> {device.isConnected ? 'Connected' : 'Disconnected'}
              </Typography>

              <Typography variant="body1" gutterBottom>
               <span style={{color:"red"}}>{device.registerPhoneResponse && device.registerPhoneResponse.error && device.registerPhoneResponse.error.message ? device.registerPhoneResponse.error.error_user_title : "" }</span>
              </Typography>

              {/* Actions */}
              <Box sx={{ display: 'flex', gap: 1, marginTop: 2 }}>
                {
                  /*
                <Button
                  variant="contained"
                  color="secondary"
                  size="small"
                  onClick={() => deleteDevice(device)}
                >
                  Delete
                </Button>
                  */
                }

                
                <Button
                  variant="contained"
                  color="primary"
                  size="small"
                  onClick={() => inbox(device)}
                >
                  Inbox
                </Button>
                <Button
                style={{marginLeft:"2px"}}
                  variant="contained"
                  color={device.default ? "primary" :  "ordinary" }
                  size="small"
                  onClick={() => savewhatsappPhoneId(device)}
                >
                  set Default
                </Button>
              </Box>
            </CardContent>
          </Card>
        </Grid>
      ))}
    </Grid>
          <br/>
        
        </Box>
      </GridItem>
    </GridContainer>
  );
};

export default FacebookWhatsAppSignup;
